import {createAction, props} from '@ngrx/store';
import {AssignmentSolution} from '../models/assignment-solution.model';


export const assignmentSolutionLoaded = createAction(
  "[Assignment Solution Effect] Assignment Solution Loaded",
  props<{solution: AssignmentSolution}>()
);

export const assignmentSolutionCreated = createAction(
  "[Assignment Screen] New Assignment Solution Uploaded",
  props<{solution: Partial<AssignmentSolution>}>()
);


export const assignmentSolutionPurged = createAction(
  "[Assignments Screen] New Solution Uploaded",
  props<{assignmentSolutionId:string}>()
)
